<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Deleted service accounts</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/${tid}`" class="btn btn-link btn-sm">
                        <i class="fa fa-cog" aria-hidden="true"></i>
                        Active service accounts
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/locked/${tid}`" class="btn btn-link btn-sm">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        Locked service accounts
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <p class="text-muted">Deleted service accounts that have been disabled.</p>
            <UsersTable v-if="deletedServiceAccounts.length" :users="deletedServiceAccounts"></UsersTable>
            <h4 v-else>No deleted service accounts</h4>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import UsersTable from '@Organizations/Users/Components/UsersTable.vue'
    import { useSearchAllUsersQueryV1 } from '@Organizations/Users/queries-vue-composables'

    // ---------------- route ----------------

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    // ---------------- query ----------------
    // active=false, locked=false, deleted=true, includeServiceAccounts=true

    const {
        runSearchAllUsersQueryV1,
        modelSearchAllUsersQueryV1: allUsersSearchResult
    } = useSearchAllUsersQueryV1(tid, '', false, false, true, true)

    const users = computed(() => allUsersSearchResult.value?.Users ?? [])
    const deletedServiceAccounts = users // already filtered by query

    onMounted(() =>
    {
        document.title = 'Deleted service accounts'
        runSearchAllUsersQueryV1()
    })
</script>
